import { AdminUsersRole } from 'stores/users/types';
import { IValidationStatusOption } from './types';
import { defaultSelectStyles } from 'components/Inputs/SelectComponent';

export const availableRoles: AdminUsersRole[] = ['super-admin', 'admin'];

export const validationStatusOptions: IValidationStatusOption[] = [
  { id: 'true', name: 'valid' },
  { id: 'false', name: 'notValid' },
];

export const DEFAULT_SELECT_STYLES = {
  ...defaultSelectStyles,
  selectStyle: { minWidth: 170, maxWidth: 360, flex: '2 1 100%' },
};

export const FIRST_ROW_SELECT_STYLES = {
  ...DEFAULT_SELECT_STYLES,
  controlStyles: { ...defaultSelectStyles.controlStyles, minHeight: 50 },
};
